import React from 'react';
import SectionRenderer from '../../../renderer/SectionRenderer';

/**
 * Layout component for rendering sections on public pages.
 * Thin wrapper around the unified SectionRenderer with mode="public".
 */
export const LayoutComponent = ({ content, sectionId }) => {
  return <SectionRenderer content={content} sectionId={sectionId} mode="public" />;
};

export default LayoutComponent;
